import { render, staticRenderFns } from "./conversation-item.vue?vue&type=template&id=9cd59936&scoped=true&"
import script from "./conversation-item.vue?vue&type=script&lang=js&"
export * from "./conversation-item.vue?vue&type=script&lang=js&"
import style0 from "./conversation-item.vue?vue&type=style&index=0&id=9cd59936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd59936",
  null
  
)

export default component.exports